document.addEventListener('DOMContentLoaded', function () {

  const faqSections = document.querySelectorAll('.randolph-faq');

  faqSections.forEach(function (section) {

    const faqItems = section.querySelectorAll('.randolph-faq__item');

    faqItems.forEach(function (item) {

      const button = item.querySelector('.randolph-faq__question');
      const answer = item.querySelector('.randolph-faq__answer');

      if (!button || !answer) return;

      button.addEventListener('click', function () {

        const isOpen = item.classList.contains('is-open');

        /*
         * Close other FAQs
         */
        faqItems.forEach(function (otherItem) {

          const otherButton =
            otherItem.querySelector('.randolph-faq__question');

          const otherAnswer =
            otherItem.querySelector('.randolph-faq__answer');

          if (otherItem !== item) {

            otherItem.classList.remove('is-open');

            if (otherButton) {
              otherButton.setAttribute('aria-expanded', 'false');
            }

            if (otherAnswer) {
              otherAnswer.hidden = true;
            }
          }

        });

        /*
         * Toggle current FAQ
         */
        if (isOpen) {

          item.classList.remove('is-open');

          button.setAttribute('aria-expanded', 'false');

          answer.hidden = true;

        } else {

          item.classList.add('is-open');

          button.setAttribute('aria-expanded', 'true');

          answer.hidden = false;

        }

      });

    });

  });

});